var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5168\\u5C40\\u529F\\u80FD",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u89D2\\u8272\\u7BA1\\u7406",
    transform: "translate(-989.000000, -359.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-12",
    transform: "translate(890.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-18",
    transform: "translate(64.000000, 348.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu",
    transform: "translate(35.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0.85,
    opacity: 0,
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125,2.5 L1.875,2.5 C1.80625,2.5 1.75,2.55625 1.75,2.625 L1.75,3.625 C1.75,3.69375 1.80625,3.75 1.875,3.75 L14.125,3.75 C14.19375,3.75 14.25,3.69375 14.25,3.625 L14.25,2.625 C14.25,2.55625 14.19375,2.5 14.125,2.5 Z M14.125,12.25 L1.875,12.25 C1.80625,12.25 1.75,12.30625 1.75,12.375 L1.75,13.375 C1.75,13.44375 1.80625,13.5 1.875,13.5 L14.125,13.5 C14.19375,13.5 14.25,13.44375 14.25,13.375 L14.25,12.375 C14.25,12.30625 14.19375,12.25 14.125,12.25 Z M14.125,7.375 L1.875,7.375 C1.80625,7.375 1.75,7.43125 1.75,7.5 L1.75,8.5 C1.75,8.56875 1.80625,8.625 1.875,8.625 L14.125,8.625 C14.19375,8.625 14.25,8.56875 14.25,8.5 L14.25,7.5 C14.25,7.43125 14.19375,7.375 14.125,7.375 Z",
    id: "\\u5F62\\u72B6",
    fillOpacity: 0.65
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.8f4532246b9064ac8feb9f8d43a9073c.svg";
export { ForwardRef as ReactComponent };